import axios from '../index';

export const requestResources = () => axios.get('/fhir/DocumentReference/education-resources');

export const requestResourcesFaq = ({ lang }) => axios.get(`/fhir/DocumentReference/faq-${lang}`);

export const requestGetResourceImage = ({ url }) => axios.get(`/fhir/${url}`);

export const requestGetResourceFile = ({ url }) => axios.get(`/fhir/${url}`);

export const requestGetPatientsResourcesStatuses = ({ patientId }) =>
  axios.get(`/fhir/QuestionnaireResponse?patient=${patientId}&questionnaire=resource-statuses`);

export const requestPutPatientsStatuses = ({ resourceId, resource }) =>
  axios.put(`/fhir/QuestionnaireResponse/${resourceId}`, resource);
